import zepto from 'autocomplete.js/zepto';
export default zepto;



// WEBPACK FOOTER //
// ./src/lib/zepto.js